import { HomePage } from './pages/home';

import React from 'react'

const App = () => {
  return (
    <div>
      <HomePage />
    </div>
  )
}

export default App
